export const isFullStatic = false
export const staticPath = "/Users/phordiienko/Sites/Vaimo/project-diptyque-revamp-vsf2/scripts/deploy/tmp_stage_release-12.5.0_rc1/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"